import type { FC } from 'react'
import { useState } from 'react'

import { Container } from '@skytech/ui/Container'
import { useQuery } from '@tanstack/react-query'
import { useNavigate, useParams } from 'react-router-dom'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import queries from '@/modules/admin/queries'
import adminResources from '@/modules/admin/resources'

import { Form } from './Form'
import { InfoCard } from './InfoCard'

import './index.styles.scss'

export const AssetDetails: FC = () => {
  const navigate = useNavigate()
  const translate = useTranslation()
  const [userTypeId, setUserTypeId] = useState<number | null>(null)
  const params = useParams()
  const assetId = Number(params.id)

  const { data: asset } = useQuery(queries.adminAsset(assetId), () =>
    adminResources.getAsset(assetId)
  )

  if (isNaN(assetId)) throw Error(translate('Asset ID is not a number!'))

  return (
    <Container onSwipedLeft={() => navigate('/admin/assets')} className="asset-details">
      <Container.Header>
        <Translation id="Asset details" /> ({assetId})
      </Container.Header>

      <InfoCard userTypeId={userTypeId || asset?.userTypeId || null} />

      <section className="asset-details-content">
        <Form
          assetId={assetId}
          onChangeUserTypeId={(_userTypeId: number) => setUserTypeId(_userTypeId)}
        />
      </section>
    </Container>
  )
}
